// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { css } from "styled-components";

scheduleReminderModalStyles.startDatePicker = {
    ...scheduleReminderModalStyles.startDatePicker,
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = {
    ...scheduleReminderModalStyles.endDatePicker,
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.startDateGridItem = {
    ...scheduleReminderModalStyles.startDateGridItem,
    width: [12, 12, 12, 6, 6],
};

scheduleReminderModalStyles.endDateGridItem = {
    ...scheduleReminderModalStyles.endDateGridItem,
    width: [12, 12, 12, 6, 6],
};
